import React from 'react';
import { createRoot } from 'react-dom/client';
import { calc } from '@ok/blade';

import './index.less';

const thousandFormat = calc.thousandFormat;
const RECURRING_URL = '/recurring-buy';
const PLAN_RULE_API = '/v2/asset/transaction/public/planRule';
const CURRENCIES_API =
  '/v2/asset/transaction/public/currencies?checkOnline=true&dynamicQuotePrecision=true&instrument=recurring';

const { ont } = window.utils;
const { cdnBaseUrl } = window.okGlobal;

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      minPayment: 1000,
      maxPayment: 200000,
      planTypes: ['每日', '毎週', '隔週', '毎月'],
      currencies: [
        'BTC',
        'ADA',
        'AVAX',
        'BAT',
        'DEP',
        'ENJ',
        'IOST',
        'LSK',
        'QTUM',
        'TRX',
        'XLM',
        'ZIL',
      ],
    };
  }

  componentDidMount() {
    this.getPlanConfig();
    window.seoMonitor.act('web_recurringbuy_introduction_exposure');
  }

  handleBtnClick = () => {
    window.location.href = RECURRING_URL;
  };

  getPlanConfig = () => {
    if (ont) {
      ont.get(PLAN_RULE_API).then((res) => {
        const { data } = res;
        const { maxPayment, minPayment, planTypes } = data.data;
        this.setState({
          maxPayment,
          minPayment,
          planTypes: planTypes.map((item) => {
            return item.typeName;
          }),
        });
      });

      ont.get(CURRENCIES_API).then((res) => {
        const { data: currencies } = res.data;
        this.setState({
          currencies: currencies.map((item) => {
            return item.baseCurrencySymbol;
          }),
        });
      });
    }
  };

  render() {
    const { minPayment, maxPayment, planTypes, currencies } = this.state;
    const { innerWidth } = window;
    const isSm = innerWidth < 767;

    const recurringReason = {
      title: 'OKJ積立が選ばれる理由',
      reasons: [
        {
          num: '01',
          title: '様々な暗号資産に対応',
          info: 'BTC（ビットコイン）はもちろん、様々なアルトコインの積立設定ができます。',
        },
        {
          num: '02',
          title: 'コツコツ簡単投資',
          info: '簡単な操作で積立設定するだけで、購入タイミングに悩まず、定期的に少額で自動購入することができます。',
        },
        {
          num: '03',
          title: 'すぐ始められる',
          info: '積立設定後、すぐに積立購入が開始します。',
        },
        {
          num: '04',
          title: '多様な設定機能',
          info: `４つの積立頻度（${planTypes.join(
            '、'
          )}）と、1,000円から20万円の範囲で自由に金額を指定できます。`,
        },
      ],
    };

    const introduction = [
      {
        label: '積立プラン',
        value: planTypes.join('・'),
      },
      {
        label: '対象銘柄',
        value: currencies.join('、'),
      },
      {
        label: '積立可能指定金額',
        value: `${thousandFormat(minPayment)}円～${thousandFormat(
          maxPayment
        )}円（1円単位）`,
      },
      {
        label: '積立開始日',
        value: '設定完了から30秒以内に開始されます',
      },
      {
        label: '積立手数料',
        value: 'なし',
      },
      {
        label: '引き落とし口座',
        value:
          '入出金口座（ 銀行口座からの自動引き落としには対応しておりません ）',
      },
    ];

    let chartImgUrl = `${cdnBaseUrl}/cdn/assets/imgs/recurring/chart_pc.png`;
    let iconImgUrl = `${cdnBaseUrl}/cdn/assets/imgs/recurring/icon_pc.png`;

    if (isSm) {
      chartImgUrl = `${cdnBaseUrl}/cdn/assets/imgs/recurring/chart_sm.png`;
      iconImgUrl = `${cdnBaseUrl}/cdn/assets/imgs/recurring/icon_sm.png`;
    }

    return (
      <div className="recurring-box">
        <div className="recurring-title">
          <div className="recurring-info">
            <div className="info-title">暗号資産積立</div>
            <div className="info-box">暗号資産を定期的に購入できます</div>
            <div
              className="recurring-btn"
              onClick={() => {
                window.seoMonitor.act(
                  'web_recurringbuy_introduction_top_button_click'
                );
                this.handleBtnClick();
              }}
            >
              積立をはじめる
            </div>
          </div>
          <div className="recurring-icon">
            <img src={iconImgUrl} alt="icon" />
          </div>
        </div>

        <div className="recurring-reason-wrapper">
          <div className="recurring-reason-box">
            <div className="reason-title">
              <span>{recurringReason.title}</span>
            </div>
            <div className="reason-box-wrapper">
              {recurringReason.reasons.map((reason) => {
                return (
                  <div className="reason-box" key={reason.title}>
                    <div className="reason-icon-box">{reason.num}</div>
                    <div className="reason-info-box">
                      <div className="reason-info-title">{reason.title}</div>
                      <div className="reason-info">{reason.info}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="recurring-method">
          <div className="method-info-wrapper">
            <div className="method-title">
              <span>分散投資</span>
              <span>ドル・コスト平均法</span>
            </div>
            <div className="method-info">
              積立サービスは、決まったタイミングで決まった額を購入することで、長期的に取得価格が平準化され、一度に大量に購入するよりも価格変動リスクを抑えることが可能です。
            </div>
          </div>
          <div className="method-chart">
            <img src={chartImgUrl} alt="chart" />
          </div>
        </div>

        <div className="introduction-box">
          <div className="introduction-box-inner">
            <div className="introduction-title">OKJ積立概要</div>
            {introduction.map((item) => {
              return (
                <div className="introduction-item" key={item.label}>
                  <div className="item-label">{item.label}</div>
                  <div className="item-value">{item.value}</div>
                </div>
              );
            })}
            <div className="button-btn-box">
              <div
                className="recurring-btn"
                onClick={() => {
                  window.seoMonitor.act(
                    'web_recurringbuy_introduction_buttom_button_click'
                  );
                  this.handleBtnClick();
                }}
              >
                積立をはじめる
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
